import React from "react";

// Search input matching the Figma "Input -> Search" (frame at 1.8537x -> real
// px): 450px wide, 41px tall, 5px radius, rgba(110,108,113,0.3) hairline border,
// 16px #6E6C71 Ubuntu Light text.
//
// @param {string} value - Current search term.
// @param {Function} onChange - Called with the new term string.
// @param {string} [placeholder]
const SearchBox = ({ value, onChange, placeholder = "Search..." }) => (
  <div className="relative" style={{ width: 450, maxWidth: "100%" }}>
    <input
      type="text"
      value={value}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      className="w-full bg-white font-light text-gray-700 focus:outline-none"
      style={{
        fontSize: 16,
        height: 41,
        padding: "0 44px 0 10px",
        borderRadius: 5,
        border: "1px solid rgba(110, 108, 113, 0.3)",
      }}
    />
    <div className="absolute inset-y-0 right-0 flex items-center" style={{ paddingRight: 12, pointerEvents: "none" }}>
      <svg className="text-gray-500" width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    </div>
  </div>
);

export default SearchBox;
